import {EventsApi, EventDetailApi, EnrollmentActionsApi, GradesApi} from '../../src/_api/classes/src'
import {asyncLazySingleton} from "../_common/common";

export const eventsApi = new asyncLazySingleton(async () => new EventsApi())
export const eventDetailApi = new asyncLazySingleton(async () => new EventDetailApi())
export const enrollmentApi = new asyncLazySingleton(async () => new EnrollmentActionsApi())
export const classGradesApi = new asyncLazySingleton(async () => new GradesApi())
